'use client'

import { Dialog, Cell, Text, Button, Image } from '@vinted/web-ui'

type Props = {
  show: boolean
  iconPath: string
  title: string
  description: string
  closeButtonText: string
  onClose: () => void
}

const InformationModal = ({
  show,
  iconPath,
  title,
  description,
  closeButtonText,
  onClose,
}: Props) => {
  return (
    <Dialog show={show}>
      <div className="u-ui-padding-vertical-large">
        <Cell>
          <div className="u-flexbox u-justify-content-center">
            <Image src={iconPath} size={Image.Size.X2Large} alt="" />
          </div>
        </Cell>
        <Cell>
          <Text
            as="h1"
            text={title}
            type={Text.Type.Heading}
            width={Text.Width.Parent}
            alignment={Text.Alignment.Center}
          />
        </Cell>
        <Cell>
          <Text as="span" html text={description} type={Text.Type.Body} />
        </Cell>
        <Cell>
          <Button text={closeButtonText} styling={Button.Styling.Filled} onClick={onClose} />
        </Cell>
      </div>
    </Dialog>
  )
}

export default InformationModal
